import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../shared/services/auth/auth.service';
import { GaStateService } from '../../shared/services/ga-state.service';
import { STATE_REPORT } from '../../shared/app-states';

interface ILink {
  sref:string;
  text:string;
}

@Component({
  selector: 'home',
  template: `
    <div class="home">

      <h2><i class="fa fa-home"></i> Home</h2>

      <p>Good {{ timeOfDay }}, {{ username }}.<br> Welcome to ACSL Global Access.</p>
      <p>What would you like to do?</p>

      <ul>
        <li *ngFor="let link of links; trackByProp:'text'"><a [uiSref]="link.sref">{{link.text}}</a></li>
      </ul>

    </div>
  `
})
export class HomeComponent implements OnInit {
  public timeOfDay:string;
  public username:string;
  public links:Array<ILink> = [];

  constructor(
    private authService:AuthService,
    private gaStateService:GaStateService
  ) {
    /**/
  }

  public ngOnInit():void {
    const now:Date = new Date();
    const hour:number = now.getHours();

    if (hour < 12) {
      this.timeOfDay = 'morning';
    } else if (hour < 18) {
      this.timeOfDay = 'afternoon';
    } else {
      this.timeOfDay = 'evening';
    }

    this.username = this.authService.getCurrentUser().name;

    /*
     https://ga.acslworld.com/ga2/#/reports/206?autoload=true&filters=Deiopen%091&filters=Deneeds_pod%091&filters=Dedocok_pod%090&filters=Dedate1%0901%252F01%252F2010&showfilters=false
     */
    this.links.push({
      text: 'Upload Proof of Delivery',
      sref: this.gaStateService.createSREF(STATE_REPORT, {
        autoload: true,
        reportId: 206,
        filters: [
          'Deiopen\t1',
          'Deneeds_pod\t1',
          'Dedocok_pod\t0',
          'Dedate1\t01/01/2010'
        ]
      })
    });
  }

  public logout():void {
    this.authService.performLogout();
  }
}